"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGGEDOUT = exports.LOGGEDIN = void 0;
exports.LOGGEDIN = 'loggedIn';
exports.LOGGEDOUT = 'loggedOut';
